import React from 'react';
import {
    Box,
    Column,
    FlexBox,
    FluidImage,
    GridContainer,
    Row,
    SquareImageContainer,
    Typography,
    responsive,
} from '@vp/swan';
import { __ } from '@99designs/i18n';

const ResponsiveStepDescription = responsive(Typography);

export function InactiveApplications() {
    return (
        <FlexBox flexDirection="column" alignItems="center" my={8}>
            <Box>
                <Box mx={3} mb={7}>
                    <Typography fontSkin="title-headline" mb={2}>
                        {__('What happens next...')}
                    </Typography>
                    <Typography fontSkin="body-standard">
                        {__('Designers will soon express interest in your project here')}
                    </Typography>
                </Box>
                <HowItWorksStepCards />
            </Box>
        </FlexBox>
    );
}

function HowItWorksStepCards() {
    const cardSteps = [
        {
            image: 'https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/expert_services/Matching/job-step-1.png',
            number: 1,
            title: __('Designers pitch for your project'),
            description: __(
                'Designers whose skills and preferences are a good fit for your project will now review your brief and let you know they are interested.'
            ),
        },
        {
            image: 'https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/expert_services/Matching/job-step-2.png',
            number: 2,
            title: __('Select your designer'),
            description: __(
                'As designers express interest in your project, they will appear here. You can view their portfolios, profiles, and reviews to help choose a designer to work with.'
            ),
        },
        {
            image: 'https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/expert_services/Matching/job-step-3.png',
            number: 3,
            title: __('Your project kicks off'),
            description: __(
                "Once you've selected a designer, the project will officially launch and they will message you with any questions or updates."
            ),
        },
    ];

    return (
        <GridContainer mb={8}>
            <Row>
                {cardSteps.map(({ image, number, title, description }) => (
                    <Column span={4} px={6} key={`image-step-${number}`}>
                        <SquareImageContainer style={{ height: '173px' }} mb={6}>
                            <FluidImage src={image} alt={title} />
                        </SquareImageContainer>
                        <FlexBox>
                            <Typography fontSkin="title-headline" mr={4} textColor={'subtle'}>
                                {number.toString().padStart(2, '0')}
                            </Typography>
                            <Box>
                                <Typography fontSkin="title-item" mb={2}>
                                    {title}
                                </Typography>
                                <ResponsiveStepDescription
                                    xs={{ fontSize: 'small' }}
                                    md={{
                                        style: {
                                            fontSize: '16px',
                                            width: '230px',
                                        },
                                    }}
                                >
                                    {description}
                                </ResponsiveStepDescription>
                            </Box>
                        </FlexBox>
                    </Column>
                ))}
            </Row>
        </GridContainer>
    );
}
